import React from 'react';
import { Input, Button, CheckboxTable, Select, PaperClip, Textarea } from 'components';
import { NewsService } from 'services';
import { RootState } from 'reducers';
import { RouteComponentProps } from 'react-router-dom';
import { Globals, Constants, checkPermission } from 'utils';
import { WhiteImage } from 'assets/img';
import { AddIcon, TrashIcon } from 'assets/icons';

interface Props {
	onClose?: any;
	item?: any;
}

class ModalCreate extends React.Component<Props> {

	state = {
		form: {
			title: '',
			text: ''
		},
		image: null
	}

	componentDidMount() {
		this.setState({
			form: {
				...this.state.form,
				title: this.props.item?.title || '',
				text: this.props.item?.text || '',
			}
		});
	}

	submit = async (e: any) => {
		e.preventDefault();	

		if (!this.props.item?.id && !this.state.image) {
			Globals.showError("Por favor, ingrese una imagen principal");
			return;
		}

		let params: any = {
			...this.state.form,
			hasFile: true,
			// @ts-ignore,
			image: this.state.image?.value || ''
		}

		if (this.props.item?.id) {
			params.news_id = this.props.item?.id;
		}

		await NewsService.admin.save(params);
		this.props.onClose();
		Globals.showSuccess("Se ha creado la noticia correctamente");
	}

	change = (e: any,callback = () => {}) => {
		this.setState({
			form: {
				...this.state.form,
				[e.target.name]: e.target.value
			}
		},callback);
	}
	
	render() {
		return (
			<div id="modal-create-news">
				<form className="row" onSubmit={ this.submit }>
					<div className="col-md-12">
						<div className="container-image">
							<PaperClip
								formats={['png', 'jpg', 'jpeg']}
								value={this.state.image}
								width={1080}
								height={1080}
								onChange={(e: any) => {
									this.setState({
										image: e.target
									})
								}}>
								<div className="image">
									{/*
									// @ts-ignore */}
									<img src={this.state.image?.dataURL || (this.props.item?.image && Constants.BASE_STORAGE + this.props.item?.image) || WhiteImage} />
								</div>
							</PaperClip>
							<p>Subir imagen con una resolución máxima de 1080px*1080px</p>
						</div>
						<Input
							color="white"
							value={ this.state.form.title }
							name="title" 
							placeholder="Título del artículo"
							onChange={ this.change } />
						<Textarea
							rows={ 10 }
							color="white"
							value={ this.state.form.text }
							name="text" 
							placeholder="Contenido"
							onChange={ this.change } />
					</div>
					<div className="col-md-12 text-center">
						<Button className="btn-submit" type="submit">
							Guardar
						</Button>
					</div>
				</form>
			</div>
		)
	}
}

export default ModalCreate;